import { createChatBotMessage } from 'react-chatbot-kit';
import { MessageCircle } from 'lucide-react';
import React from 'react';

// Bot Avatar Component with logo
const BotAvatar = () => {
  return (
    <div className="react-chatbot-kit-chat-bot-avatar">
      <div className="react-chatbot-kit-chat-bot-avatar-container">
        <img
          src="/botlogo.jpg"
          alt="Bot Avatar"
          className="w-10 h-10 rounded-full object-cover"
        />
      </div>
    </div>
  );
};

const config = {
  initialMessages: [
    createChatBotMessage("Hi! I'm your Learning Assistant. Ask me anything about your course!")
  ],
  botName: "Learning Bot",
  customStyles: {
    botMessageBox: {
      backgroundColor: '#429ccd',
    },
    chatButton: {
      backgroundColor: '#429ccd',
    },
  },
  customComponents: {
    botAvatar: (props) => <BotAvatar {...props} />,
  },
};

export default config;
